export default class UserEducationJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.userEducationEndpoint}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.userEducationEndpoint}/${id}`, payload)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.userEducationEndpoint, {
      params
    })
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.userEducationEndpoint}/${id}`)
  }

  get(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.userEducationEndpoint}/${id}`)
  }
}
